module.exports = __webpack_public_path__ + "img/small_truck_green.2db75619.svg";